/* eslint-disable */
import {API} from "../api";

export class LogAudit {
  constructor(rotina) {
    API.defaults.headers.RotinaId = localStorage.getItem("rotina_id") + (rotina !== undefined ? rotina : '')
  }
}
